<script>
import cloneDeep from "lodash/cloneDeep";
import required from "vuelidate/lib/validators/required";
import DatePicker from "vue2-datepicker";
import PrintOptions from "@/components/modals/print-options.vue";
import RawData from "@/components/widgets/raw-data.vue";

export default {
  props: {
    propertyRow: {
      type: Object,
      required: true,
    },
    allowAssign: {
      type: Boolean,
    },
    allowEdit: {
      type: Boolean,
    },
    allowTransfer: {
      type: Boolean,
    },
    employeeData: {
      type: Object,
    },
    locationData: {
      type: Object,
    },
  },
  components: {
    DatePicker,
    PrintOptions,
    RawData
  },
  data() {
    return {
      submitted: false,
      modalTitle: "",
      form: {
        propertyId: "",
        dateAssigned: "",
        employeeIdNumber: "",
        propertyLocationId: "",
        assignNotes: "",
        assignmentType: "",
        assignmentNumber: "",
        renewalDate: "",
      },
      transferForm: {
        propertyAssignmentId: null,
        type: "",
        reason: "",
        transferToEmployeeId: "",
        remarks: "",
      },
      returnForm: {
        id: null,
        returnNotes: "",
        dateReturned: "",
      },
      assignmentNumber: true,
      employeeName: "",
      location: "",
      getEmployeeType: "",
      accountableEmployee: null,
    };
  },
  validations: {
    form: {
      dateAssigned: { required },
      employeeIdNumber: { required },
      propertyLocationId: { required },
      assignmentType: { required },
    },
  },
  watch: {
    employeeData() {
      var firstname = this.employeeData.firstName;
      var lastname = this.employeeData.lastName;
      if (this.getEmployeeType == "history-modal-assign") {
        this.form.employeeIdNumber = this.employeeData.idNo;
        this.employeeName = firstname.concat(" ", lastname);
      } else if (this.getEmployeeType == "history-modal-transfer") {
        this.transferForm.transferToEmployeeId = this.employeeData.idNo;
        this.employeeName = firstname.concat(" ", lastname);
      }
    },
    locationData() {
      this.form.propertyLocationId = this.locationData.location.id;
      this.location = this.locationData.location.location;
    },
  },
  methods: {
    getAssignments(row) {
      row.assignVisible = !row.assignVisible;
      if (row.assignVisible) {
        row.assignLoading = true;
        setTimeout(() => {
          row.assignmentHistory = [];
          this.$store
            .dispatch("propertyassignment/GetPropertyAssignment", row.propertyId ? row.propertyId : row.id)
            .then((res) => {
              row.assignLoading = false;
              row.assignmentHistory = res.data.reverse();
            })
            .catch(() => {
              row.assignLoading = false;
              this.showToast(
                "Something went wrong - Getting assignments!",
                "error"
              );
            });
        }, 1000);
      }
    },
    onSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.form.dateAssigned = this.getDate(this.form.dateAssigned);
        this.form.renewalDate =
          this.form.renewalDate != ""
            ? this.getDate(this.form.renewalDate)
            : "0001-01-01T00:00:00";
        if (this.form.id > 0) {
          this.$store
            .dispatch("propertyassignment/UpdatePropertyAssignment", this.form)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var index = this.propertyRow.assignmentHistory.findIndex(
                (item) => item.id == this.form.id
              );
              this.propertyRow.assignmentHistory.splice(index, 1, res.data);
              this.showToast("Successfully updated!", "success");
              this.$bvModal.hide(
                `assignmenthistory-modal-assignment-${this.propertyRow.id}`
              );
            })
            .catch((err) => {
              this.showToast(
                "Something went wrong - Updating assignment!",
                "error"
              );
            });
        } else {
          this.$store
            .dispatch("propertyassignment/AddPropertyAssignment", this.form)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.dropData();
              this.showToast("Successfully assigned!", "success");
              this.$bvModal.hide(
                `assignmenthistory-modal-assignment-${this.propertyRow.id}`
              );
            })
            .catch((err) => {
              this.showToast(
                "Something went wrong - Assigning property!",
                "error"
              );
            });
        }
        this.submitted = false;
      }
    },
    assignProperty(props) {
      this.onReset();
      this.assignmentNumber = true;
      this.form.propertyId = props.id;
      this.form.dateAssigned = new Date();
      this.modalTitle = "Assign Officer";
      this.$bvModal.show(
        `assignmenthistory-modal-assignment-${this.propertyRow.id}`
      );
    },
    updateAssignment(props) {
      this.onReset();
      this.assignmentNumber = false;
      this.form = cloneDeep(props);
      this.form.dateAssigned = !props.dateAssigned.includes("0001-01-01")
        ? new Date(props.dateAssigned)
        : "";
      this.form.renewalDate = !props.renewalDate.includes("0001-01-01")
        ? new Date(props.renewalDate)
        : "";
      this.employeeName = props.accountableOfficer.firstName.concat(
        " ",
        props.accountableOfficer.lastName
      );
      this.location = props.propertyLocation.location;
      this.modalTitle = "Update Assignment";
      this.$bvModal.show(
        `assignmenthistory-modal-assignment-${this.propertyRow.id}`
      );
    },
    deleteAssignment(props) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("propertyassignment/DeletePropertyAssignment", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var index = this.propertyRow.assignmentHistory.findIndex(
                (item) => item.id == props.id
              );
              this.propertyRow.assignmentHistory.splice(index, 1);
              this.showToast("Successfully deleted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    onReturn() {
      this.submitted = true;
      if (
        this.returnForm.dateReturned == "" ||
        this.returnForm.dateReturned == null
      )
        return;
      else {
        if (this.returnForm.id) {
          this.$swal({
            title: "Are you sure?",
            text: "You are about to return the selected property.",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#5c636a",
            confirmButtonText: "Yes, return it!",
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              this.returnForm.dateReturned = this.getDate(
                this.returnForm.dateReturned
              );
              var prop = [];
              prop.push(this.returnForm);
              this.$store
                .dispatch(
                  "propertyassignment/ReturnMultiplePropertyAssignment",
                  prop
                )
                .then(() => {
                  var index = this.propertyRow.assignmentHistory.findIndex(
                    (item) => item.id == this.returnForm.id
                  );
                  this.propertyRow.assignmentHistory[index].dateReturned =
                    this.returnForm.dateReturned;
                  this.$forceUpdate();
                  this.showToast("Successfully returned", "success");
                  this.$bvModal.hide(
                    `assignmenthistory-modal-return-${this.propertyRow.id}`
                  );
                })
                .catch((err) => {
                  this.showToast("Cannot be returned!", "error");
                });
            }
          });
        } else {
          this.onReturnMultipleItems();
        }
      }
      this.submitted = false;
    },
    returnItem(id) {
      this.onReset();
      this.returnForm.id = id;
      this.returnForm.dateReturned = new Date();
      this.returnForm.returnNotes = "";
      this.modalTitle = "Return Item";
      this.$bvModal.show(
        `assignmenthistory-modal-return-${this.propertyRow.id}`
      );
    },
    onTransferItem() {
      this.submitted = true;
      if (this.checkTransferForm()) {
        return;
      } else {
        this.$swal({
          title: "Are you sure?",
          text: "You are about to transfer the selected property.",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#5c636a",
          confirmButtonText: "Yes, transfer it!",
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            this.$store
              .dispatch("propertytransfer/CreatePropertyTransfer", [
                this.transferForm,
              ])
              .then(() => {
                this.showToast("Successfully transferred", "success");
                this.$bvModal.hide(
                  `assignmenthistory-modal-transfer-${this.propertyRow.id}`
                );
              })
              .catch((err) => {
                this.showToast("Cannot be transferred!", "error");
              });
          }
        });
      }
      this.submitted = false;
    },
    transferItem(id) {
      this.onReset();
      this.transferForm.propertyAssignmentId = id;
      this.transferForm.type = "Reassignment";
      this.modalTitle = "Transfer Item";
      this.$bvModal.show(
        `assignmenthistory-modal-transfer-${this.propertyRow.id}`
      );
    },
    checkTransferForm() {
      if (
        this.transferForm.type === "" ||
        this.transferForm.type === null ||
        this.transferForm.reason === "" ||
        this.transferForm.reason === null ||
        this.transferForm.transferToEmployeeId === "" ||
        this.transferForm.transferToEmployeeId === null
      ) {
        return true;
      } else return false;
    },
    checkAssignmentStatus(assignment) {
      var today = new Date();
      if (assignment.dateReturned.includes("0001-01-01")) {
        if (new Date(assignment.renewalDate) < today) {
          return "renew";
        } else return "active";
      } else {
        if (new Date(assignment.dateReturned) > new Date(assignment.dateAssigned)) {
          return 'returned';
        }
        return 'active'
      }
    },
    async printIcfEmployee() {
      var apiUrl = `api/Report/Property/ICF`;
      var routeVariables = [this.accountableEmployee.idNo];
      this.$refs.assignmentHistoryPrintOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
      });
      this.$bvModal.show("print-options-modal");
    },
    async printPpeEmployee() {
      var apiUrl = `api/Report/Property/Inventory/PPE`;
      var routeVariables = [this.accountableEmployee.idNo];
      this.$refs.assignmentHistoryPrintOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
      });
      this.$bvModal.show("print-options-modal");
    },
    showEmployee(props) {
      if (props) {
        this.accountableEmployee = null;
        this.accountableEmployee = cloneDeep(props);
        this.modalTitle = "Accountable Officer Detail";
        this.$bvModal.show(
          `assignmenthistory-modal-accountableEmployee-${this.propertyRow.id}`
        );
      }
    },
    onReset() {
      this.submitted = false;
      this.form = {
        propertyId: "",
        dateAssigned: "",
        employeeIdNumber: "",
        propertyLocationId: "",
        assignNotes: "",
        assignmentType: "",
        assignmentNumber: "",
        renewalDate: "",
      };
      this.transferForm = {
        propertyAssignmentId: null,
        type: "",
        reason: "",
        transferToEmployeeId: "",
        remarks: "",
      };
      this.returnForm = {
        id: null,
        returnNotes: "",
        dateReturned: "",
      };
      this.employeeName = "";
      this.location = "";
    },
    getEmployee(type) {
      this.$emit("getEmployee", type);
      this.getEmployeeType = type;
    },
    getLocation() {
      this.$emit("getLocation", "assignment-modal");
    },
    dropData() {
      this.$emit("dropData", this.propertyRow);
    },
  },
};
</script>

<template>
  <div>
    <!-- Create / Update Assignment -->
    <b-modal :id="`assignmenthistory-modal-assignment-${propertyRow.id}`" :title="modalTitle" size="md"
      title-class="font-18" hide-footer no-close-on-backdrop>
      <form @submit.prevent="onSubmit" class="needs-validation" ref="fcForm">
        <div v-if="!form.id > 0" class="mb-3">
          <div class="form-check form-checkbox-outline form-check-success">
            <input type="checkbox" id="autoGenerate" checked="checked" class="form-check-input"
              v-model="assignmentNumber" /><label for="autoGenerate" class="form-check-label">
              Auto Generate PAR/ICS Number
            </label>
          </div>
        </div>
        <b-collapse :visible="!assignmentNumber">
          <div v-if="!assignmentNumber" class="mb-3">
            <label for="assignmentNumber">PAR/ICS Number </label>
            <input id="assignmentNumber" type="text" v-model="form.assignmentNumber"
              placeholder="Enter PAR/ICS Number..." class="form-control" autocomplete="off" />
          </div>
        </b-collapse>
        <div v-if="!form.id > 0" class="mb-3">
          <label for="employee">Employee</label>
          <b-input-group>
            <template #append>
              <b-button @click="getEmployee('history-modal-assign')" variant="outline-info"><i
                  class="mdi mdi-clipboard-text-search-outline"></i></b-button>
            </template>
            <input autocomplete="off" type="text" disabled placeholder="Search Employee..." class="form-control" :class="{
              'is-invalid': submitted && $v.form.employeeIdNumber.$error,
            }" v-model="employeeName" />
          </b-input-group>
          <div v-if="submitted && $v.form.employeeIdNumber.$error" class="invalid-feedback">
            <span v-if="!$v.form.employeeIdNumber.required">This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="dateAssigned">Date Assigned</label>
          <date-picker v-model="form.dateAssigned" :first-day-of-week="1" lang="en" placeholder="Enter Date Assigned..."
            :class="{
              'is-invalid': submitted && $v.form.dateAssigned.$error,
            }"></date-picker>
          <div v-if="submitted && $v.form.dateAssigned.$error" class="invalid-feedback">
            <span v-if="!$v.form.dateAssigned.required">This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="renewalDate">Renewal Date</label>
          <date-picker v-model="form.renewalDate" :first-day-of-week="1" lang="en"
            placeholder="Enter Renewal Date..."></date-picker>
        </div>
        <div class="mb-3">
          <label for="employee">Location</label>
          <b-input-group>
            <template #append>
              <b-button @click="getLocation()" variant="outline-info"><i
                  class="mdi mdi-clipboard-text-search-outline"></i></b-button>
            </template>
            <input autocomplete="off" type="text" disabled placeholder="Search Location..." class="form-control" :class="{
              'is-invalid': submitted && $v.form.propertyLocationId.$error,
            }" v-model="location" />
          </b-input-group>
          <div v-if="submitted && $v.form.propertyLocationId.$error" class="invalid-feedback">
            <span v-if="!$v.form.propertyLocationId.required">This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="assignmentType">Assignment Type </label>
          <b-form-select class="form-select" :class="{
            'is-invalid': submitted && $v.form.assignmentType.$error,
          }" v-model="form.assignmentType">
            <b-form-select-option value="" disabled>Select Type...</b-form-select-option>
            <b-form-select-option value="New">New</b-form-select-option>
            <b-form-select-option value="Donation">Donation</b-form-select-option>
            <b-form-select-option value="Reassignment">Reassignment</b-form-select-option>
            <b-form-select-option value="Relocate">Relocate</b-form-select-option>
            <b-form-select-option value="Others">Others</b-form-select-option>
          </b-form-select>
          <div v-if="submitted && $v.form.assignmentType.$error" class="invalid-feedback">
            <span v-if="!$v.form.assignmentType.required">This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="assignNotes">Notes </label>
          <textarea id="assignNotes" rows="2" v-model="form.assignNotes" placeholder="Enter Notes..."
            class="form-control" autocomplete="off"></textarea>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary">
            {{ form.id > 0 ? "Update" : "Create" }}
          </button>
        </div>
      </form>
    </b-modal>
    <!-- Transfer Property -->
    <b-modal :id="`assignmenthistory-modal-transfer-${propertyRow.id}`" :title="modalTitle" size="md"
      title-class="font-18" hide-footer no-close-on-backdrop>
      <form @submit.prevent="onTransferItem" class="needs-validation" ref="fcForm">
        <div class="mb-3">
          <label for="employee">Employee</label>
          <b-input-group>
            <template #append>
              <b-button @click="getEmployee('history-modal-transfer')" variant="outline-info"><i
                  class="mdi mdi-clipboard-text-search-outline"></i></b-button>
            </template>
            <input autocomplete="off" type="text" disabled placeholder="Search Employee..." class="form-control" :class="{
              'is-invalid':
                submitted &&
                (transferForm.transferToEmployeeId == null ||
                  transferForm.transferToEmployeeId == ''),
            }" v-model="employeeName" />
          </b-input-group>
          <div v-if="
            submitted &&
            (transferForm.transferToEmployeeId == null ||
              transferForm.transferToEmployeeId == '')
          " class="invalid-feedback">
            <span>This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="assignmentType">Assignment Type </label>
          <b-form-select class="form-select" :class="{
            'is-invalid':
              submitted &&
              (transferForm.type == null || transferForm.type == ''),
          }" v-model="transferForm.type">
            <b-form-select-option value="" disabled>Select Type...</b-form-select-option>
            <b-form-select-option value="New">New</b-form-select-option>
            <b-form-select-option value="Donation">Donation</b-form-select-option>
            <b-form-select-option value="Reassignment">Reassignment</b-form-select-option>
            <b-form-select-option value="Relocate">Relocate</b-form-select-option>
            <b-form-select-option value="Others">Others</b-form-select-option>
          </b-form-select>
          <div v-if="
            submitted &&
            (transferForm.type == null || transferForm.type == '')
          " class="invalid-feedback">
            <span>This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="reason">Reason</label>
          <textarea id="reason" rows="2" v-model="transferForm.reason" placeholder="Enter Reason..."
            class="form-control" :class="{
              'is-invalid':
                submitted &&
                (transferForm.reason == null || transferForm.reason == ''),
            }" autocomplete="off"></textarea>
          <div v-if="
            submitted &&
            (transferForm.reason == null || transferForm.reason == '')
          " class="invalid-feedback">
            <span>This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="returnNotes">Remarks</label>
          <textarea id="returnNotes" rows="2" v-model="transferForm.returnNotes" placeholder="Enter Return Note..."
            class="form-control" autocomplete="off"></textarea>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary">
            Transfer Property
          </button>
        </div>
      </form>
    </b-modal>
    <!-- Return Property -->
    <b-modal :id="`assignmenthistory-modal-return-${propertyRow.id}`" :title="modalTitle" size="md"
      title-class="font-18" hide-footer no-close-on-backdrop>
      <form @submit.prevent="onReturn" class="needs-validation" ref="fcForm">
        <div class="mb-3">
          <label for="dateReturned">Date Returned </label>
          <date-picker v-model="returnForm.dateReturned" :first-day-of-week="1" lang="en"
            placeholder="Enter Date Returned..." :class="{
              'is-invalid':
                submitted &&
                (returnForm.dateReturned == '' ||
                  returnForm.dateReturned == null),
            }"></date-picker>
          <div v-if="
            submitted &&
            (returnForm.dateReturned == '' || returnForm.dateReturned == null)
          " class="invalid-feedback">
            <span>This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="returnNotes">Reason for Return: </label>
          <textarea id="returnNotes" rows="4" v-model="returnForm.returnNotes" placeholder="Enter return note..."
            class="form-control" autocomplete="off"></textarea>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary">Return Property</button>
        </div>
      </form>
    </b-modal>
    <!-- View Employee Info -->
    <b-modal :id="`assignmenthistory-modal-accountableEmployee-${propertyRow.id}`" :title="modalTitle" size="md"
      title-class="font-18" hide-footer no-close-on-backdrop>
      <div v-if="accountableEmployee && accountableEmployee.firstName">
        <div class="d-flex align-items-center">
          <div class="avatar-sm me-2">
            <span class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-16">{{
              accountableEmployee.firstName.charAt(0).toUpperCase()
            }}{{ accountableEmployee.lastName.charAt(0).toUpperCase() }}</span>
          </div>
          <div>
            <div class="mt-1">
              <h5 class="mb-0">
                {{
                  accountableEmployee.lastName.charAt(0).toUpperCase() +
                  accountableEmployee.lastName.slice(1)
                }},
                {{
                  accountableEmployee.firstName.charAt(0).toUpperCase() +
                  accountableEmployee.firstName.slice(1)
                }}
                {{
                  accountableEmployee.middleName
                    ? `${accountableEmployee.middleName
                      .charAt(0)
                      .toUpperCase()}.`
                    : ""
                }}
              </h5>
            </div>
            <div>{{ accountableEmployee.idNo }}</div>
          </div>
        </div>
        <hr class="my-3" />
        <div class="ps-3 pe-3">
          <b-row class="mb-2">
            <b-col class="p-0" sm="2">
              <b>Office</b>
            </b-col>
            <b-col :class="{ 'text-white': accountableEmployee.office }">{{
              accountableEmployee.office
                ? accountableEmployee.office
                : "No record"
            }}</b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="p-0" sm="2">
              <b>Position</b>
            </b-col>
            <b-col :class="{ 'text-white': accountableEmployee.position }">{{
              accountableEmployee.position
                ? accountableEmployee.position
                : "No record"
            }}</b-col>
          </b-row>
        </div>
        <hr class="my-3" />
        <div class="d-flex float-end">
          <button type="button" @click="printIcfEmployee"
            class="btn btn-sm btn-purple d-flex align-items-center justify-content-center ms-2">
            <i class="bx bx-printer fs-6 me-2"></i>Print ICF
          </button>
          <button type="button" @click="printPpeEmployee"
            class="btn btn-sm btn-purple d-flex align-items-center justify-content-center ms-2">
            <i class="bx bx-printer fs-6 me-2"></i>Print RPCPPE
          </button>
        </div>
      </div>
    </b-modal>

    <b-card-body class="border cursor-pointer" @click="getAssignments(propertyRow)">
      <div class="d-flex align-items-center justify-content-between">
        <h6 class="mb-0">
          <i class="bx bx-user"></i>
          Assignment History
        </h6>
        <h5 class="mb-0">
          <i class="bx bx-chevron-right rotate" :class="{
            'rotate-90': propertyRow.assignVisible,
          }"></i>
        </h5>
      </div>
    </b-card-body>
    <b-collapse :visible="propertyRow.assignVisible" role="tabpanel">
      <div v-if="propertyRow.assignVisible">
        <b-card-body v-if="propertyRow.assignLoading" class="border">
          <div class="d-flex align-items-center justify-content-center">
            <div class="preloader-component me-2">
              <div class="status">
                <div class="spinner-chase w-25px h-25px">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <h5 class="mb-0">Loading...</h5>
          </div>
        </b-card-body>
        <b-card-body v-else-if="propertyRow.assignmentHistory.length == 0" class="border">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <p class="mb-0">
              <i>No prior history</i>
            </p>

            <button v-if="allowAssign" type="button" @click="assignProperty(propertyRow)"
              class="ms-2 btn btn-sm btn-success d-flex align-items-center">
              <i class="bx bx-list-check me-2 fs-6"></i>
              Assign Accountable Officer
            </button>
          </div>
        </b-card-body>
        <b-card-body v-else class="text-muted border">
          <div v-if="allowAssign" class="d-flex justify-content-end mb-3">
            <button type="button" @click="assignProperty(propertyRow)"
              class="ms-2 btn btn-sm btn-success d-flex align-items-center">
              <i class="bx bx-list-check me-2 fs-6"></i>
              Assign Accountable Officer
            </button>
          </div>
          <ul class="verti-timeline list-unstyled ms-4" v-for="y in propertyRow.assignmentHistory" :key="y.id">
            <li class="event-list" :class="{
              active: y.dateReturned.includes('0001-01-01'),
            }">
              <div class="event-timeline-dot pt-3">
                <i class="font-size-18" :class="checkAssignmentStatus(y) == 'active'
                  ? 'bx bxs-right-arrow-circle bx-fade-right'
                  : checkAssignmentStatus(y) == 'renew'
                    ? 'bx bx-right-arrow-circle text-warning'
                    : 'bx bx-right-arrow-circle text-danger'
                  "></i>
              </div>
              <div class="media">
                <div class="d-flex justify-content-end align-items-top pt-3 ms-4 me-3" style="width: 135px">
                  <div class="pe-1">
                    <b class="font-size-16" :class="checkAssignmentStatus(y) == 'active'
                      ? 'text-success'
                      : checkAssignmentStatus(y) == 'renew'
                        ? 'text-warning'
                        : 'text-danger'
                      ">
                      {{ formatDateShort(new Date(y.dateAssigned)) }}
                    </b>
                  </div>
                  <div>
                    <i class="bx bx-right-arrow-alt font-size-16 text-info align-middle ms-2"></i>
                  </div>
                </div>
                <div class="media-body position-relative">
                  <RawData :data="y" v-if="$store.state.decrypt.isAdmin()" />
                  <div class="ps-3 pe-3 pb-3">
                    <div div class="border rounded-3 p-3">
                      <div class="d-flex align-items-start justify-content-between">
                        <div>
                          <div v-b-tooltip.top.hover="'View Details'" @click="showEmployee(y.accountableOfficer)"
                            class="cursor-pointer mb-2">
                            <h5 v-if="y.accountableOfficer" class="mb-1">
                              {{
                                y.accountableOfficer.lastName.charAt(0).toUpperCase() +
                                y.accountableOfficer.lastName.slice(1)
                              }},
                              {{
                                y.accountableOfficer.firstName.charAt(0).toUpperCase() +
                                y.accountableOfficer.firstName.slice(1)
                              }}
                              {{
                                y.accountableOfficer.middleName
                                  ? `${y.accountableOfficer.middleName.charAt(0).toUpperCase()}.`
                                  : ""
                              }}
                            </h5>
                            <h5 v-else class="mb-1">
                              ID Number: {{ y.employeeIdNumber }}
                            </h5>
                          </div>

                          <div class="d-flex flex-wrap gap-2">
                            <span class="badge bg-success">{{ propertyRow.amount >= 50000 ? "PAR" : "ICS" }}: {{
                              y.assignmentNumber }}</span>
                            <span class="badge bg-primary">{{ y.assignmentType }}</span>
                            <span :class="[
                              'badge',
                              checkAssignmentStatus(y) == 'active' ? 'bg-success' :
                                checkAssignmentStatus(y) == 'renew' ? 'bg-warning' : 'bg-danger'
                            ]">
                              {{ checkAssignmentStatus(y) == 'active' ? 'Active' :
                                checkAssignmentStatus(y) == 'renew' ? 'For Renewal' : 'Returned' }}
                            </span>
                          </div>
                        </div>

                        <div v-if="allowEdit">
                          <b-dropdown right variant="link" toggle-class="text-decoration-none p-0"
                            menu-class="dropdown-menu-end" no-caret>
                            <template #button-content>
                              <i class="mdi mdi-dots-horizontal font-size-18"></i>
                            </template>
                            <b-dropdown-item v-if="y.dateReturned.includes('0001-01-01') && allowEdit"
                              @click="returnItem(y.id)">
                              <i class="bx bx-revision font-size-16 align-middle me-1"></i>
                              Return Item
                            </b-dropdown-item>
                            <b-dropdown-item v-if="y.dateReturned.includes('0001-01-01')" @click="updateAssignment(y)">
                              <i class="mdi mdi-update font-size-16 align-middle me-1"></i>
                              Update
                            </b-dropdown-item>
                            <b-dropdown-item v-else @click="deleteAssignment(y)">
                              <i class="mdi mdi-trash-can font-size-16 align-middle me-1"></i>
                              Delete
                            </b-dropdown-item>
                          </b-dropdown>
                        </div>
                      </div>

                      <hr class="my-3">

                      <div class="row g-3">
                        <div class="col-md-6">
                          <div class="d-flex mb-2">
                            <div class="flex-shrink-0 me-3">
                              <i class="bx bx-calendar-event font-size-18 text-primary"></i>
                            </div>
                            <div class="flex-grow-1">
                              <h6 class="mb-0">Date Assigned</h6>
                              <small>{{ formatDate(new Date(y.dateAssigned)) }}</small>
                            </div>
                          </div>

                          <div class="d-flex mb-2">
                            <div class="flex-shrink-0 me-3">
                              <i class="bx bx-calendar-check font-size-18 text-warning"></i>
                            </div>
                            <div class="flex-grow-1">
                              <h6 class="mb-0">Renewal Date</h6>
                              <small>{{ y.renewalDate.includes('0001-01-01') ? 'N/A' : formatDate(new
                                Date(y.renewalDate))
                              }}</small>
                            </div>
                          </div>

                          <div class="d-flex">
                            <div class="flex-shrink-0 me-3">
                              <i class="bx bx-calendar-x font-size-18 text-danger"></i>
                            </div>
                            <div class="flex-grow-1">
                              <h6 class="mb-0">Date Returned</h6>
                              <small>{{ y.dateReturned.includes('0001-01-01') ? 'N/A' : formatDate(new
                                Date(y.dateReturned))
                              }}</small>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="d-flex mb-2">
                            <div class="flex-shrink-0 me-3">
                              <i class="bx bx-map font-size-18 text-info"></i>
                            </div>
                            <div class="flex-grow-1">
                              <h6 class="mb-0">Location</h6>
                              <small>{{ y.propertyLocation.location }}</small>
                              <div class="text-muted">
                                <small>Code: {{ y.propertyLocation.locationCode }}</small>
                              </div>
                            </div>
                          </div>

                          <div class="d-flex">
                            <div class="flex-shrink-0 me-3">
                              <i class="bx bx-note font-size-18 text-primary"></i>
                            </div>
                            <div class="flex-grow-1">
                              <h6 class="mb-0">Notes</h6>
                              <small>{{ y.assignNotes || 'No notes' }}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </b-card-body>
      </div>
    </b-collapse>
    <print-options ref="assignmentHistoryPrintOpt"></print-options>
  </div>
</template>
